import React, { ReactNode, forwardRef } from "react";
import classNames from "classnames";
import styles from "./MenuItem.module.scss";
import { SidebarOption } from "../../../core/navigation/navigation.slice";
import { strings } from "intl/fa";

interface Props {
  title: string;
  value: SidebarOption;
  selected?: boolean;
  icon?: ReactNode;
  className?: string;
  disabled?: boolean;
  onClick?: (value: SidebarOption) => void;
  isNew?: boolean;
}

const MenuItemFC = (props: Props, ref: React.Ref<HTMLDivElement>) => {
  const isLogout = props.value === SidebarOption.Logout;
  return (
    <div className={styles.MenuItem}>
      <div
        onClick={() => {
          if (!props.disabled) {
            props.onClick?.(props.value);
          }
        }}
        className={classNames(
          styles.Container,
          {
            [styles.IsSelected]: props.selected && !isLogout,
            [styles.LogoutMenuItem]: isLogout,
            [styles.IsDisabled]: props.disabled,
          },
          props.className
        )}
        ref={ref}
      >
        {props.icon}
        <p className={styles.Title}>{props.title}</p>
        {props.isNew && (
          <p className={styles.NewItem}>{strings.side_bar.new}</p>
        )}
      </div>

      {props.selected && <div className={styles.selectedLine} />}
    </div>
  );
};

const MenuItem = forwardRef(MenuItemFC);

export default MenuItem;
